<template>
    <widget-wrapper :loader="api" :title="$t('widgets.sellers.title')" id="sellers">
        <div class="table__responsive">
            <table class="table--hover--clickable">
                <thead>
                    <tr class="table__row--header table--hover--clickable__row--non_clickable">
                        <th>{{$t('widgets.sellers.columns.name')}}</th>
                        <th>{{$t('widgets.sellers.columns.appointments')}}</th>
                        <th>{{$t('widgets.sellers.columns.sold')}}</th>
                        <th>{{$t('widgets.sellers.columns.revenue')}}</th>
                        <th>{{$t('widgets.sellers.columns.conversion')}}</th>
                    </tr>
                </thead>
                <tbody>
                    <seller-row v-for="seller in sellers" :key="seller.id" v-bind="seller"
                                @click="showDetails(seller)"/>
                    <tr v-if="!sellers || !sellers.length">
                        <td colspan="10000" class="table__cell--no_data">{{$t('widgets.sellers.label_no_data')}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </widget-wrapper>
</template>
<script>
    import {Component} from 'vue-property-decorator';
    import DashboardWidget from '../DashboardWidget';
    import WidgetWrapper from '../WidgetWrapper';
    import WidgetData from '../WidgetDataDecorator';
    import SellerRow from './SellerRow';
    import Expander from '../../general/Expander';

    @Component({
        components: {
            Expander,
            SellerRow,
            WidgetWrapper
        }
    })
    export default class SellersWidget extends DashboardWidget {
        api = {
            endpoint: 'dashboard/api/sales/sales_people',
            allow404: true,
        };
        @WidgetData(() => ([
            {
                id: 1001,
                name: 'Jan van Hooijdonck',
                appointments: 20,
                sold: 20,
                revenue: 1,
            },
            {
                id: 1002,
                name: 'Pieter-Jan de Feber',
                appointments: 16,
                sold: 10,
                revenue: 2,
            },
            {
                id: 1003,
                name: 'Else Vink',
                appointments: 17,
                sold: 1,
                revenue: 3,
            },
            {
                id: 1004,
                name: 'Else Vink',
                appointments: 0,
                sold: 0,
                revenue: 4,
            },
        ]))
        sellers;

        onQueryData(response) {
            if (!response) {
                this.sellers = [];
                return;
            }
            this.sellers = response.data.map(seller => ({
                id: seller.id,
                name: seller.name,
                appointments: seller.num_appointments,
                sold: seller.num_orders,
                revenue: seller.total_ex_vat,
            }));
        }

        showDetails(seller) {
            this.$modal.show('seller-modal', {seller: seller, query: this.query});
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/widgets/sellers/SellersWidget.vue